// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"e300ef0c","453":"03346f77"}[chunkId] + ".chunk.js";
};